import React, { useState, useEffect } from "react";
import Navbar from "../../components/common/Navbar";
import { sendResult } from "../../utils/helper";

// Style
import "./LevelCuatro.scss";

// Const
import { LEFT_BARS, RIGHT_BARS } from "../../utils/consts";
import LevelComplete from "../../components/common/LevelComplete/LevelComplete";

const LevelCuatro = (props) => {
  const [leftBars, setLeftBars] = useState(LEFT_BARS);
  const [rightBars, setRightBars] = useState(RIGHT_BARS);
  const [won, setWon] = useState(false);
  const [move, setMove] = useState(false);
  const [dataPoints, setDataPoints] = useState({
    twoBtnTime: 0,
    buttonsClicked: [],
    firstFillTime: 0,
    secondBarFirstTileTime: 0,
    totalClicks: 0,
    totalTime: 0,
  });

  // Clicks
  const [clicks, setClicks] = useState(0);

  // Timer
  const [timer, setTimer] = useState(0);

  // Timer increase
  useEffect(() => {
    setTimeout(() => setTimer(timer + 1), 1000);
  }, [timer]);

  // Check if won
  useEffect(() => {
    let index = 0;
    while (index < leftBars.length) {
      if (leftBars[index] === false || rightBars[index] === false) {
        setWon(false);
        break;
      }
      index += 1;
    }
    if (index === leftBars.length) setWon(true);
    getDatapoints({ left: leftBars, right: rightBars });
  }, [leftBars, rightBars]);

  // Call won state
  useEffect(() => {
    setTimeout(() => {
      if (won) {
        getDatapoints({ left: leftBars, right: rightBars });
        const finalObj = {
          gameData: {
            levelData: [
              {
                level: 4,
                levelName: 'Charge',
                twoBtnTime: dataPoints.twoBtnTime,
                firstFillTime: dataPoints.firstFillTime,
                secondBarFirstTileTime: dataPoints.secondBarFirstTileTime,
                totalTime: timer,
                totalClicks: clicks,
                isLevelCleared: true,
                isLevelSkipped: false,
                totalHintsTaken: localStorage.getItem("totalHints"),
                timeForFirstHint: localStorage.getItem("totalHints") !== 0 ? localStorage.getItem("hint1") : 0,
                timeForSecondHint: localStorage.getItem("totalHints") !== 0 ? localStorage.getItem("hint2") : 0
              }
            ],
          }
        }
        console.log(finalObj)
        sendResult(finalObj)
        setMove(true);
      }
    }, 500);
  }, [won]);

  const getDatapoints = ({ left, right }) => {
    let tempDataPoints = { ...dataPoints };
    // Time taken to fill first block
    if (!left.includes(false) && tempDataPoints.firstFillTime === 0) {
      tempDataPoints.firstFillTime = timer;
    }

    // Time taken to move tile to second block
    if (right.includes(true) && tempDataPoints.secondBarFirstTileTime === 0) {
      tempDataPoints.secondBarFirstTileTime = timer;
    }

    // Clicks taken to fill both blocks
    // Time taken to fill both blocks
    if (
      !left.includes(false) &&
      !right.includes(false) &&
      tempDataPoints.totalClicks === 0 &&
      tempDataPoints.totalTime === 0
    ) {
      tempDataPoints.totalClicks = clicks;
      tempDataPoints.totalTime = timer;
    }

    setDataPoints(tempDataPoints);
  };

  // Add from bottom to top in left bar
  const addToLeftBar = () => {
    setClicks(clicks + 1);
    const tempBar = [...leftBars];
    let index = tempBar.length - 1;
    while (index > -1) {
      if (tempBar[index] === false) {
        tempBar[index] = true;
        break;
      }
      index -= 1;
    }
    setLeftBars(tempBar);
  };

  // Move from left bar top to right bar top
  const addToRightBar = () => {
    setClicks(clicks + 1);
    let tempLeftBar = [...leftBars];
    let tempRightBar = [...rightBars];
    if (leftBars[0] === true) {
      tempLeftBar[0] = false;
      tempRightBar[0] = true;
      setLeftBars(tempLeftBar);
      setRightBars(tempRightBar);
    }
  };

  // move from top to bottom in right bar
  const moveDownRightBar = () => {
    setClicks(clicks + 1);
    let tempBar = [...rightBars];
    tempBar.pop();
    tempBar.unshift(false);
    setRightBars(tempBar);
  };

  return (
    <div className="component-level-cuatro">
      {move && <LevelComplete levelNum={8} />}
      <Navbar won={won} levelNum={8} />
      <div className="game-div-cuatro">
        <div className="top-bars">
          <div className="left-bar bar">
            {leftBars.map((item, index) => (
              <div
                key={index}
                className={`block ${item ? "filled" : ""}`}
              ></div>
            ))}
          </div>
          <div className="right-bar bar">
            {rightBars.map((item, index) => (
              <div
                key={index}
                className={`block ${item ? "filled" : ""}`}
              ></div>
            ))}
          </div>
        </div>
        <div className="bottom-buttons">
          <div className="left-btn btn" onClick={() => addToLeftBar()}>
            <div></div>
          </div>
          <div className="center-btn btn" onClick={() => addToRightBar()}>
            <div></div>
          </div>
          <div className="right-btn btn" onClick={() => moveDownRightBar()}>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LevelCuatro;
